import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@paypalcorp/pp-react';
import TemplateData, { localsMessages } from '../utility/getTemplateData';
import _get from 'lodash/get';
import * as FPT from '../utility/fpt'

let messages = localsMessages('common/offerdetail');

class OfferSaveButton extends React.Component {
	printPage = () => {
		window.print();
		FPT.trackLinkClick('voucherprint');
	}

	sharePage = ({ title, text }) => {
		navigator.share({
			title,
			text,
		});
		FPT.trackLinkClick('vouchershare');
	}

	handleClick = (event) => {
		if (TemplateData.isdesktop || !navigator.share) {
			this.printPage();
		} else {
			const {
				offerProgram,
				txnStatement
			} = this.props;
			this.sharePage({
				title: _get(offerProgram, 'subTitle'),
				text: `${txnStatement} ${_get(offerProgram, 'description')}`
			});
		}
	};

	render() {
		return (
			<div className="ppvx_col-12 ppvx_d-flex ppvx_justify-content-center">
				<Button className="btn-wide" onClick={this.handleClick}>
					{messages.offer.button.text}
				</Button>
			</div>
		);
	}
}

OfferSaveButton.propTypes = {
	offerProgram: PropTypes.object.isRequired,
	txnStatement: PropTypes.string
};

export default OfferSaveButton;
